import { render, staticRenderFns } from "./perincian.vue?vue&type=template&id=5948e2d8&scoped=true&"
import script from "./perincian.vue?vue&type=script&lang=js&"
export * from "./perincian.vue?vue&type=script&lang=js&"
import style0 from "./perincian.vue?vue&type=style&index=0&id=5948e2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948e2d8",
  null
  
)

export default component.exports